import React from "react";
import ProfileForm from "../profileForm";
import {DEFAULT_EMPLOYEE_PROFILE} from "../../commonComponents/hooks";

export default function EmployeeProfileForm(props) {
    return <ProfileForm
        isMe={props.isMe}
        profileId={props.profileId}
        showMicroSite={false}
        showBrokerInfo={false}
        canEditPosition={true}
        isEmployee={true}
        hasActiveToggle={false}
        resourceName={'employee'}
        defaultProfileData={DEFAULT_EMPLOYEE_PROFILE}
        canEditID={true}
        showSalesPersonInfo={false}
        canEditAffiliation={false}
    />
}